import React from 'react';

interface TooltipProps {
  text: string;
  children: React.ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
  /** Classe Tailwind de largeur fixe, ex: "w-48", "w-56", "w-64" */
  width?: string;
  /** "div" pour les éléments bloc (barres, sections) — évite le conflit inline-flex */
  as?: 'span' | 'div';
  className?: string;
}

const Tooltip: React.FC<TooltipProps> = ({ text, children, position = 'top', width = 'w-52', as: Tag = 'span', className }) => {
  const posClass =
    position === 'top'    ? 'bottom-full left-1/2 -translate-x-1/2 mb-2' :
    position === 'bottom' ? 'top-full left-1/2 -translate-x-1/2 mt-2' :
    position === 'left'   ? 'right-full top-1/2 -translate-y-1/2 mr-2' :
                            'left-full top-1/2 -translate-y-1/2 ml-2';

  const arrowClass =
    position === 'top'    ? 'top-full left-1/2 -translate-x-1/2 border-t-gray-800 border-x-transparent border-b-transparent' :
    position === 'bottom' ? 'bottom-full left-1/2 -translate-x-1/2 border-b-gray-800 border-x-transparent border-t-transparent' :
    position === 'left'   ? 'left-full top-1/2 -translate-y-1/2 border-l-gray-800 border-y-transparent border-r-transparent' :
                            'right-full top-1/2 -translate-y-1/2 border-r-gray-800 border-y-transparent border-l-transparent';

  const baseClass = Tag === 'div'
    ? `relative group/tooltip w-full${className ? ` ${className}` : ''}`
    : `relative group/tooltip inline-flex items-center${className ? ` ${className}` : ''}`;

  return (
    <Tag className={baseClass}>
      {children}
      <span
        className={`pointer-events-none absolute ${posClass} ${width} rounded-md bg-gray-800 px-2.5 py-2 text-xs text-white leading-snug opacity-0 group-hover/tooltip:opacity-100 transition-opacity duration-150 z-[9999] shadow-lg whitespace-pre-wrap`}
      >
        {text}
        <span className={`absolute border-4 ${arrowClass}`} />
      </span>
    </Tag>
  );
};

export default Tooltip;
